import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c0b1cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "asset",
  class: "w-full"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "stepper__title" }
const _hoisted_4 = { class: "stepper__subtitle" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = { class: "bg-black bg-opacity-50 rounded-lg p-2 mr-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex flex-col text-left" }
const _hoisted_13 = { class: "opacity-70" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col items-right text-right"
}
const _hoisted_15 = { class: "amount" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-70 text-xs" }, "Available", -1))
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_18 = { class: "text-xl text-center mt-8 mx-4 max-w-[250px] opacity-70" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center my-4 max-w-[250px] opacity-60" }, " Please return to the previous step, and select another origin chain ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll = _resolveComponent("scroll")!
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tokensWithBalance.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_Transition, {
              name: "up",
              mode: "out-in",
              appear: ""
            }, {
              default: _withCtx(() => [
                (!_ctx.selectedToken.symbol)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.subtitle), 1))
                  : (_ctx.affected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.subtitle), 1))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_scroll, {
            height: 400,
            class: "stepper__content"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokensWithBalance, (token) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: token.key,
                  class: _normalizeClass(["stepper__option", {
            'stepper__option--active': token.symbol === _ctx.selectedToken.symbol,
          }]),
                  onClick: ($event: any) => (_ctx.selectToken(token))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: token.icon,
                        class: "h-4 w-4"
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(token.symbol) + " ", 1),
                        _createElementVNode("span", _hoisted_13, " to " + _toDisplayString(_ctx.getDisplayName(token.tokenIdentifier.domain)), 1)
                      ])
                    ])
                  ]),
                  (_ctx.balances[token.key])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.toDecimals(_ctx.balances[token.key].toString(), token.decimals, 6)), 1),
                        _hoisted_16
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_8))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_nomad_button, {
            primary: "",
            class: "stepper__continue",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('next'))),
            disabled: !_ctx.valid
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Continue ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_nomad_button, {
            class: "w-full flex justify-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back ")
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, " You have no assets available to bridge back from " + _toDisplayString(_ctx.getDisplayName(_ctx.origin)), 1),
          _hoisted_19,
          _createVNode(_component_nomad_button, {
            primary: "",
            class: "stepper__continue",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Change Network ")
            ]),
            _: 1
          })
        ]))
  ]))
}